module.exports = __webpack_public_path__ + "static/cover-c3bd0d75bfa7628598722b90031d0d37.jpg";